export default "/_next/static/images/efe0bc377014cf7b2a4a470d0ba77024.jpg";